/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-restricted-syntax */
import React, { memo, useState } from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tabs, Tab, Box } from '@material-ui/core';
import styles from './manageCustomers.styles';
import { Typography } from '../../components/Typography';
import { Card } from '../../components/Card';
import { WordConfirmationModal } from './components';
import { Button } from '../../components/Button';

import { AddMemberModal } from '../members/components';
import { SelectDeviceModal } from '../devices/components';
import { AddGroupModal } from '../group/components';
import DeleteConfirmationModal from './components/deleteConfirmationModal';
import EditGroupModal from '../group/components/editGroupModal';
import { IGetMemberResponse, IMembersState } from '../members/members.slice';
import { IGroupsState, emptyGroup } from '../group/groups.slice';
import { IUser } from '../auth/auth.slice';
import { IDevicesState } from '../devices/devices.slice';
import { IRequestParams } from '../../components/types';
import { useUser } from '../../components/form/user-form/use-user';
import { validateUser } from '../../models/validate-user';
import type { User } from '../../models/user';
import DevicesCard from './devices-card';
import { MemberInfoCard } from './member-info-card';
import { TabPanel } from './tab-panel';
import MemberDataCard from './member-data-card';
import { GroupManageCard } from './group-manage-card';

interface IManageCustomerView extends WithStyles<typeof styles> {
  selectedCustomer: IUser;
  allCustomer: boolean;
  selectMember: IMembersState;
  membersList: IGetMemberResponse;
  subadminList: IGetMemberResponse;
  selectDevice: IDevicesState;
  selectGroup: IGroupsState;
  handleAddMember: (data: string) => void;
  handleEditCustomer: (data: any) => void;
  handleSelectDevice: (data: any) => void;
  handleAddGroup: (data: any) => void;
  backToCustomers: () => void;
  handleDeleteMember: (data: string) => void;
  handleDeleteDevice: (data: any) => void;
  handleDeleteGroup: (data: string) => void;
  handleEditGroup: (data: any) => void;
  handleDeleteCustomer: () => void;
  handleSuspendCustomer: () => void;
  handleUnsuspendCustomer: () => void;
  handleDeleteGroupMember: (id: string) => void;
  handleGetDevices: ({ limit, offset, sortOrder }: IRequestParams) => void;
  handleGetGroups: ({ limit, offset, sortOrder }: IRequestParams) => void;
  handleGetMembers: ({ limit, offset, sortOrder }: IRequestParams) => void;
}

const ManageCustomerView: React.FC<IManageCustomerView> = ({
  classes,
  selectedCustomer,
  allCustomer,
  selectMember,
  membersList,
  subadminList,
  selectDevice,
  selectGroup,
  handleAddMember,
  handleEditCustomer,
  handleSelectDevice,
  handleAddGroup,
  backToCustomers,
  handleDeleteMember,
  handleDeleteDevice,
  handleDeleteGroup,
  handleEditGroup,
  handleDeleteCustomer,
  handleSuspendCustomer,
  handleUnsuspendCustomer,
  handleDeleteGroupMember,
  handleGetDevices,
  handleGetMembers,
}: IManageCustomerView) => {
  const [openAddMemberModal, setOpenAddMemberModal] = useState(false);
  const [openAddDeviceModal, setOpenAddDeviceModal] = useState(false);
  const [openAddGroupModal, setOpenAddGroupModal] = useState(false);
  const [openEditGroupModal, setOpenEditGroupModal] = useState({
    open: false,
    selectedGroup: emptyGroup,
  });
  const [
    openDeleteWordConfirmationModal,
    setOpenDeleteWordConfirmationModal,
  ] = useState(false);
  const [removeConfirmationModal, setRemoveConfirmationModal] = useState({
    open: false,
    name: '',
    onclick: null,
  });
  const [
    openRevokeConfirmationModal,
    setOpenRevokeConfirmationModal,
  ] = useState(false);

  const intl = useIntl();
  const { updateUser, user } = useUser({ ...(selectedCustomer as User) });
  const { hasErrors } = validateUser(user, ['password', 'parentId']);

  const [tabValue, setTabValue] = useState(0);
  const isCustomer = user?.role === 'customer';

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const isSuspend = user.status === 'suspend' ? true : false;

  // eslint-disable-next-line no-shadow
  const onClickRemove = (name: string, onclick: any) => {
    setRemoveConfirmationModal({
      open: true,
      name,
      onclick,
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.topWrapper} id="customers-view">
        <IconButton color="inherit" size="medium" onClick={backToCustomers}>
          <ArrowBackIosIcon fontSize="inherit" />
        </IconButton>
        <Typography variant="h3" component="h2" color="textPrimary">
          {isCustomer ? (
            <FormattedMessage id="edit_customer" />
          ) : (
            <FormattedMessage id="edit_subadmin" />
          )}
        </Typography>
      </div>
      <div className={classes.bottomWrapper}>
        <Card>
          <div className={classes.cardContentWrapper}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="content tabs"
            >
              <Tab
                label={intl.formatMessage({
                  id: 'details',
                })}
              />
              <Tab label="Members" />
              <Tab label="Group" />
              <Tab label="Devices" />
              <Tab label="Access" />
            </Tabs>
            <Box style={{ padding: '20px' }}>
              <TabPanel value={tabValue} index={0}>
                <MemberInfoCard
                  allCustomer={allCustomer}
                  subadminList={subadminList}
                  updateUser={updateUser}
                  user={user}
                  handleEditCustomer={handleEditCustomer}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <MemberDataCard
                  selectMember={selectMember}
                  membersList={membersList}
                  handleDeleteMember={handleDeleteMember}
                  handleGetMembers={handleGetMembers}
                  onAddMember={() => setOpenAddMemberModal(true)}
                  onRemoveMember={(name, callback) => {
                    onClickRemove(name, () => {
                      callback();
                      setRemoveConfirmationModal({
                        open: false,
                        name: '',
                        onclick: null,
                      });
                    });
                  }}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <GroupManageCard
                  selectGroup={selectGroup}
                  onAddGroup={() => setOpenAddGroupModal(true)}
                  onEditGroup={(group) =>
                    setOpenEditGroupModal({
                      open: true,
                      selectedGroup: group,
                    })
                  }
                  onRemoveGroup={(name, callback) => {
                    onClickRemove(name, () => {
                      callback();
                      setRemoveConfirmationModal({
                        open: false,
                        name: '',
                        onclick: null,
                      });
                    });
                  }}
                  onRemoveGroupMember={(memberName, callback) => {
                    onClickRemove(memberName, () => {
                      callback();
                      setRemoveConfirmationModal({
                        open: false,
                        name: '',
                        onclick: null,
                      });
                    });
                  }}
                  handleDeleteGroup={handleDeleteGroup}
                  handleDeleteGroupMember={handleDeleteGroupMember}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={3}>
                <DevicesCard
                  selectDevice={selectDevice}
                  onAddDevice={() => setOpenAddDeviceModal(true)}
                  onRemoveDevice={(deviceName, callback) => {
                    onClickRemove(deviceName, () => {
                      callback();
                      setRemoveConfirmationModal({
                        open: false,
                        name: '',
                        onclick: null,
                      });
                    });
                  }}
                  handleDeleteDevice={handleDeleteDevice}
                  handleGetDevices={handleGetDevices}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={4}>
                <div className={classes.deleteButtonsWrapper}>
                  <Button
                    id="delete-customer"
                    label={intl.formatMessage({
                      id: 'delete_customer_record',
                    })}
                    variant="contained"
                    onClick={() => setOpenDeleteWordConfirmationModal(true)}
                  />
                  <Button
                    id="revoke-member"
                    label={
                      isSuspend
                        ? intl.formatMessage({
                            id: 'gain_system_access',
                          })
                        : intl.formatMessage({
                            id: 'revoke_system_access',
                          })
                    }
                    variant="contained"
                    onClick={() => setOpenRevokeConfirmationModal(true)}
                  />
                </div>
              </TabPanel>
            </Box>
          </div>
        </Card>
      </div>
      <AddGroupModal
        selectGroup={selectGroup}
        selectMember={selectMember}
        selectDevice={selectDevice}
        open={openAddGroupModal}
        handleClose={() => setOpenAddGroupModal(false)}
        handleAddGroup={handleAddGroup}
      />
      <EditGroupModal
        selectGroup={selectGroup}
        selectMember={selectMember}
        selectDevice={selectDevice}
        open={openEditGroupModal.open}
        handleClose={() =>
          setOpenEditGroupModal({
            open: false,
            selectedGroup: emptyGroup,
          })
        }
        handleEditGroup={handleEditGroup}
        selectedGroup={openEditGroupModal.selectedGroup}
        allGroups={false}
      />
      <SelectDeviceModal
        open={openAddDeviceModal}
        handleClose={() => setOpenAddDeviceModal(false)}
        handleSelectDevice={handleSelectDevice}
        selectDevice={selectDevice}
      />
      <AddMemberModal
        selectMember={selectMember}
        open={openAddMemberModal}
        handleClose={() => setOpenAddMemberModal(false)}
        handleAddMember={handleAddMember}
      />
      <WordConfirmationModal
        open={openDeleteWordConfirmationModal}
        typeWord={intl.formatMessage({
          id: 'delete',
        })}
        modalTitle={intl.formatMessage({
          id: 'delete_user',
        })}
        modalDescription={intl.formatMessage(
          {
            id: 'are_you_sure_you_want_to_delete',
          },
          {
            name: selectedCustomer?.profile?.name,
            action: intl.formatMessage({
              id: 'delete',
            }),
          }
        )}
        actinButtonLabel="delete"
        onClickActionButton={() => {
          handleDeleteCustomer();
          setOpenDeleteWordConfirmationModal(false);
          backToCustomers();
        }}
        handleClose={() => setOpenDeleteWordConfirmationModal(false)}
      />
      <WordConfirmationModal
        open={openRevokeConfirmationModal}
        typeWord={intl.formatMessage({
          id: isSuspend ? 'unsuspend' : 'suspend',
        })}
        modalTitle={
          isSuspend
            ? intl.formatMessage({
                id: 'gain_system_access',
              })
            : intl.formatMessage({
                id: 'revoke_system_access',
              })
        }
        modalDescription={intl.formatMessage(
          {
            id: 'are_your_sure_you_want_to_revoke_unsuspend',
          },
          {
            name: selectedCustomer?.profile?.name,
            action: intl.formatMessage({
              id: isSuspend ? 'unsuspend' : 'suspend',
            }),
          }
        )}
        onClickActionButton={() => {
          if (isSuspend) {
            handleUnsuspendCustomer();
          } else {
            handleSuspendCustomer();
          }
          setOpenRevokeConfirmationModal(false);
        }}
        actinButtonLabel={isSuspend ? 'unsuspend' : 'suspend'}
        handleClose={() => setOpenRevokeConfirmationModal(false)}
      />
      <DeleteConfirmationModal
        open={removeConfirmationModal.open}
        onClickActionButton={removeConfirmationModal.onclick}
        handleClose={() =>
          setRemoveConfirmationModal({
            open: false,
            name: '',
            onclick: null,
          })
        }
        modalDescription={intl.formatMessage(
          {
            id: 'are_you_sure_you_want_to_remove',
          },
          {
            name: removeConfirmationModal.name,
          }
        )}
      />
    </div>
  );
};

export default memo(withStyles(styles)(ManageCustomerView));
